import React from 'react';
import './App.css';
import Board from './components/Board';
import {initState, saveGuess, getTodaysState} from './util/State';

initState();

const initialState = getTodaysState()

function App() {
  const addTry = React.useCallback((guess) => {
    saveGuess(guess)
  }, []);

  return (
    <div className="App">
      <div className="AppTitle">
        <div className="Row">
          <div className="Box">S</div>
          <div className="Box">A</div>
          <div className="Box">N</div>
          <div className="Box">A</div>
          <div className="Box">R</div>
          <div className="Box">I</div>
        </div>
      </div>
      <Board addTry={addTry} initialState={initialState} />
    </div>
  );
}

export default App;
